import * as lib from '../lib'
import { IFetchItems, IFetchAccountTeam } from '../types'
import * as helpers from '../helpers'

export const listAccountTeam = async (
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<IFetchAccountTeam>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: lib.filterSetup([]),
		//TODO: sort after BE is ready (and remove manual sort below)
		//s: lib.sortSetup([['role.teamReport', 'asc']]),
		s: lib.sortSetup([]),
		skip: lib.skipSetup(0),
		take: lib.takeSetup('all'),
	}
	const uri: string = 'account/teams'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchAccountTeam>>(uri, options)

	return {
		items: data?.items?.sort(helpers.strComparator) ?? [],
		total: data?.items?.length ?? 0
	}
}
